// Experience review API — eligibility check + submission for the one-question
// "How was your overall experience?" prompt shown at the 2nd trade / 2nd deposit.
import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

// ─── Types ──────────────────────────────────────────────────────────────────

export type ReviewTrigger = 'second_trade' | 'second_deposit' | 'manual';

export interface ReviewEligibility {
  eligible: boolean;
  reason: ReviewTrigger | null;
  hasReviewed: boolean;
  tradeCount?: number;
  depositCount?: number;
}

export interface SubmitReviewPayload {
  comment: string;
  trigger?: ReviewTrigger;
  rating?: number;
}

export interface Review {
  id: number;
  comment: string;
  trigger: ReviewTrigger | null;
  rating: number | null;
  createdAt: string;
}

// ─── API ────────────────────────────────────────────────────────────────────

export const reviewApi = {
  getEligibility: async (): Promise<ReviewEligibility> => {
    const { data } = await axiosClient.get<{ success: boolean; data: ReviewEligibility }>(
      API_ENDPOINTS.REVIEWS.ELIGIBILITY,
    );
    return data?.data ?? { eligible: false, reason: null, hasReviewed: false };
  },

  submitReview: async (payload: SubmitReviewPayload): Promise<Review> => {
    const { data } = await axiosClient.post<{ success: boolean; data: Review }>(
      API_ENDPOINTS.REVIEWS.SUBMIT,
      payload,
    );
    return data?.data;
  },
};
